<template>
  <div>
    <!-- Header Card -->
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="card-body p-15 p-sm-20 p-md-25">
        <h3 class="text-lg font-semibold">{{ pickupNote.note_ref }}</h3>
        <p class="mt-2 text-gray-600">
          Date de création :
          <b v-if="pickupNote.created_at">{{
            getDate(pickupNote.created_at)
          }}</b>
        </p>
      </div>
    </div>

    <!-- Liste des nouveaux colis -->
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="border-b p-4">
        <h3 class="text-lg font-semibold">Liste des nouveaux colis</h3>
      </div>
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            v-if="pickupNote.statut == 0"
            @click="addNewReq"
          >
            Ajouter
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          </a>
        </div>
        <div class="d-flex align-items-center">
          <input
            type="text"
            v-model="searchTerm1"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
          />
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <vue-good-table
          :columns="columns"
          :rows="rows1"
          :row-key="'id'"
          :select-options="{
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          }"
          @selected-rows-change="selectionChanged"
          @select-all="onSelectAll"
        >
          <template #emptystate>
            <div class="text-center py-4 text-gray">
              Aucune entrées correspondants trouvés
            </div>
          </template>

          <template #table-row="props">
            <template v-if="props.column.field === 'code'">
              <h6>
                {{ props.row.magasin }}
              </h6>
              <span>{{ props.row.city_name }}</span>
            </template>

            <template v-else-if="props.column.field === 'note'">
              <p>{{ props.row.note }}</p>
            </template>

            <template v-else-if="props.column.field === 'created_at'">
              <span class="whitespace-nowrap">
                {{ getDate(props.row.created_at) }}
              </span>
            </template>

            <template v-else-if="props.column.field === 'type'">
              <p v-if="props.row.type == 'SIMPLE_PARCEL'">Colis Simple</p>
              <p v-else-if="props.row.type == 'SIMPLE_STOCK'">Colis Stock</p>
            </template>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <TablePager
          :pagination="pagerNew"
          v-model:per-page="perPageNew"
          @paginate="getNewRequests"
        />
      </div>
    </div>

    <!-- Liste des colis ajoutés -->
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div class="border-b p-4">
        <h3 class="text-lg font-semibold">Liste des colis ajoutés</h3>
      </div>
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <div class="d-sm-flex align-items-center">
          <a
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            type="button"
            v-if="pickupNote.statut == 0"
            @click="removeNewReq"
          >
            Supprimer
            <i class="flaticon-delete position-relative ms-5 fs-12"></i>
          </a>
        </div>
        <div class="d-flex align-items-center">
          <input
            type="text"
            v-model="searchTerm2"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
          />
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <vue-good-table
          :columns="columns"
          :row-key="'id'"
          :rows="rows2"
          responsive
          :select-options="{
            enabled: true,
            clearSelectionText: 'Annuler',
            selectionText: 'Demandes Sélectionées',
          }"
          @select-all="onSelectAllColis"
          @selected-rows-change="selectionChangedColis"
        >
          <template #emptystate>
            <div class="text-center py-4 text-gray">
              Aucune entrées correspondants trouvés
            </div>
          </template>

          <template #table-row="props">
            <template v-if="props.column.field === 'code'">
              <h6>
                {{ props.row.magasin }}
              </h6>
              <span>{{ props.row.city_name }}</span>
            </template>

            <template v-else-if="props.column.field === 'note'">
              <p>{{ props.row.note }}</p>
            </template>

            <template v-else-if="props.column.field === 'created_at'">
              <span class="whitespace-nowrap">
                {{ getDate(props.row.created_at) }}
              </span>
            </template>

            <template v-else-if="props.column.field === 'type'">
              <p v-if="props.row.type == 'SIMPLE_PARCEL'">Colis Simple</p>
              <p v-else-if="props.row.type == 'SIMPLE_STOCK'">Colis Stock</p>
            </template>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
        <TablePager
          :pagination="pagerNote"
          v-model:per-page="perPageNote"
          @paginate="getNoteRequests"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useServerTable } from "@/composables/useServerTable";
import { useRoute } from "vue-router";
// import PaginatorContent from "@/components/PaginatorContent.vue";

export default defineComponent({
  name: "EditPickup",

  components: {
    // CreateNewUserModal,
  },
  setup: () => {
    const { showToast } = useAppToast();
    const route = useRoute();
    const auth = useAuthStore();
    const user = auth.user;

    // props / states
    const pickupNote = ref<any>({});

    const direction = ref("ltr");

    // dummy columns and rows
    const columns = ref([
      { label: "Code", field: "code" },
      { label: "Note", field: "note" },
      { label: "Type", field: "type" },
      { label: "Date Création", field: "created_at" },
    ]);

    const selectedRows = ref([]);
    const selectedNewRows = ref([]);

    // Both tables are paginated and searched by the API: one page of requests at a time.
    const {
      rows: rows1,
      pager: pagerNew,
      searchTerm: searchTerm1,
      perPage: perPageNew,
      load: getNewRequests,
    } = useServerTable({
      url: "/api/auth/NewPickupRequest",
    });
    const {
      rows: rows2,
      pager: pagerNote,
      searchTerm: searchTerm2,
      perPage: perPageNote,
      load: getNoteRequests,
    } = useServerTable({
      url: "/api/auth/RequestInNote",
      params: () => ({ note_ref: route.params.refCode, note_id: route.params.id }),
      pick: (data) => data.data,
    });

    // methods
    const getDate = (date) =>
      new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

    async function addNewReq() {
      console.log(selectedRows);
      try {
        if (!selectedRows.value.length) {
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("UserID", String(user?.id));
        data.append("requests", JSON.stringify(selectedRows.value));
        data.append("note_id", String(route.params.id));
        data.append(
          "note_ref",
          Array.isArray(route.params.refCode)
            ? route.params.refCode[0]
            : String(route.params.refCode)
        );

        const res = await api.post(`/api/auth/AddToNotePickup`, data);

        if (res.data.msg === "success") {
          // Play audio
          const audio = new Audio("/sound.mp3");
          audio.play();

          showToast("Ajoutées avec succès", "success");
          fetchData(); // refresh data
        } else {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Erreur lors de l’ajout", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    async function removeNewReq() {
      try {
        if (!selectedNewRows.value.length) {
          // show toast if no selection
          showToast("Veuillez sélectionner des lignes", "error");
          return;
        }

        const data = new FormData();
        data.append("UserID", user?.id);
        data.append("requests", JSON.stringify(selectedNewRows.value));
        data.append(
          "note_ref",
          Array.isArray(route.params.refCode)
            ? route.params.refCode[0]
            : String(route.params.refCode)
        );
        data.append("note_id", String(route.params.id));

        const res = await api.post(`/api/auth/RemoveFromNotePickup`, data);

        if (res.data.msg === "success") {
          const audio = new Audio("/sound.mp3");
          audio.play();

          showToast("Supprimées avec succès", "success");
          fetchData(); // refresh table data
        } else {
          const audio = new Audio("/erro.mp3");
          audio.play();
          showToast("Une erreur est survenue, veuillez réessayer", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      }
    }

    function selectionChanged(params)  {
      selectedRows.value = params.selectedRows;
    }

    function onSelectAll(params)  {
      selectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params) {
      console.log(params)

      selectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params) {
      console.log(params)
      selectedNewRows.value = params.selectedRows;
    }

    const fetchData = async () => {
      try {
        const res = await api.get(
          `/api/auth/NotePickupShow?note_ref=${route.params.refCode}&note_id=${route.params.id}`
        );
        pickupNote.value = res.data; // update reactive ref
      } catch (err) {
        console.error("Erreur lors du chargement du bon:", err);
      }

      try {
        await Promise.all([getNewRequests(1), getNoteRequests(1)]);
      } catch (err) {
        console.error(err);
      }
    };

    onMounted(async () => {
      fetchData();
    });

    return {
      pickupNote,
      pagerNew,
      pagerNote,
      perPageNew,
      perPageNote,
      getNewRequests,
      getNoteRequests,
      columns,
      rows2,
      rows1,
      getDate,
      addNewReq,
      removeNewReq,
      onSelectAll,
      selectionChanged,
      selectionChangedColis,
      onSelectAllColis,
      searchTerm1,
      searchTerm2,
      direction,
      selectedNewRows,
      selectedRows,
    };
  },
});
</script>